import { ICONS } from '@client/constants/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/risk')({
    staticData: {
        breadcrumb: {
            title: 'Risk',
            inactive: true,
        },
        roles: ['user', 'shared_edit_user', 'org_admin'],
        modules: ['risk'],
        ui: {
            icon: ICONS.risk,
        },
    },
    component: Outlet,
});
